/**
 * Utility functions for parsing and formatting maxDataProcTime
 * Format: "0001-01-01T00:03:00Z"
 */

export interface ParsedDataProcTime {
  hours: string;
  minutes: string;
}

/**
 * Parse maxDataProcTime string to hours and minutes
 * @param maxDataProcTime - Format: "0001-01-01T00:03:00Z"
 * @returns Object with hours and minutes as strings with leading zeros
 */
export const parseMaxDataProcTime = (maxDataProcTime?: string): ParsedDataProcTime => {
  if (!maxDataProcTime) {
    return { hours: '00', minutes: '00' };
  }

  try {
    // Extract time portion: "0001-01-01T00:03:00Z" -> "00:03:00"
    const timePart = maxDataProcTime.split('T')[1];
    if (!timePart) {
      return { hours: '00', minutes: '00' };
    }

    // Split time: "00:03:00" -> ["00", "03", "00"]
    const [hours, minutes] = timePart.split(':');

    return {
      hours: hours || '00',
      minutes: minutes || '00',
    };
  } catch {
    return { hours: '00', minutes: '00' };
  }
};

/**
 * Format hours and minutes to maxDataProcTime string
 * @param hours - Hours string (00-12)
 * @param minutes - Minutes string (00-59)
 * @returns Format: "0001-01-01T00:03:00Z"
 */
export const formatMaxDataProcTime = (hours: string, minutes: string): string => {
  return `0001-01-01T${hours}:${minutes}:00Z`;
};

/**
 * Generate hours options for dropdown (00-12)
 */
export const getHoursOptions = (): string[] => {
  return Array.from({ length: 13 }, (_, i) => i.toString().padStart(2, '0'));
};

/**
 * Generate minutes options for dropdown (00-59)
 */
export const getMinutesOptions = (): string[] => {
  return Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0'));
};
